import { render, staticRenderFns } from "./ReceiptItem.vue?vue&type=template&id=43c6c9bc"
import script from "./ReceiptItem.vue?vue&type=script&lang=js"
export * from "./ReceiptItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports